import ReactGA from "react-ga";
import ReactPixel from 'react-facebook-pixel';
import { Cookies } from 'react-cookie';

export const trackEvent = ( label, category, action ) => {
  //if( getCookieValue('cookies-accepted-stats') == 1) {
    ReactGA.event({
      category,
      action,
      label,
    });
  //}

  //if( getCookieValue('cookies-accepted-marketing') == 1) {
    ReactPixel.track(label,  '');
  //}

  // console.log("Tracked Event: " + label);
}

const getCookieValue = (name) => document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)').pop() || ''



// WEBPACK FOOTER //
// /src/utils/eventTracking.js